import "core-js/modules/es.reflect.construct.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* ---------------------------------------------------- */
// Dependencies

/* ---------------------------------------------------- */
import Component from '../core/component';
import { imagesLoaded } from '../services/imagesloaded';
import { clamp } from '../core/math';
import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
/* ---------------------------------------------------- */
// Constants & variables

/* ---------------------------------------------------- */

var defaults = {
  name: 'carousel',
  $: {
    wrapper: '.carousel__wrapper',
    inner: '.carousel__images',
    items: '.carousel__media',
    arrows: '.carousel__arrow'
  },
  $$: {
    btnPrevious: '*[data-action="previous"]',
    btnNext: '*[data-action="next"]'
  }
};
var properties = {
  elmWidth: 0,
  innerWidth: 0,
  innerHeight: 0,
  minX: 0,
  images: [],
  draggable: null,
  initialized: false
};
/* ---------------------------------------------------- */
// Module

/* ---------------------------------------------------- */

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  var _super = _createSuper(Carousel);

  function Carousel(element) {
    var _this2;

    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);

    _classCallCheck(this, Carousel);

    // element
    var $element = Component.isElement(element);

    if (typeof $element === 'undefined' || !$element) {
      throw new Error('Passed element is not a valid element');
    } // options


    var opts = Object.assign(Object.create(null), defaults, options);
    _this = _super.call(this, opts); // properties

    Object.assign(_assertThisInitialized(_this), Component.cloneDeep(properties));
    _this.$element = $element; // eslint-disable-next-line prefer-rest-params

    (_this2 = _this).init.apply(_this2, arguments);

    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Carousel, [{
    key: "init",
    value: function init() {
      var _get2,
          _this3 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _get(_getPrototypeOf(Carousel.prototype), "init", this)).call.apply(_get2, [this].concat(args));

      this.$select(); // shortcut to execute some function in the next frame

      this.rAF = function (fn) {
        for (var _len2 = arguments.length, ags = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          ags[_key2 - 1] = arguments[_key2];
        }

        if (typeof _this3[fn] === 'function') {
          window.requestAnimationFrame(function () {
            return _this3[fn].apply(_this3, ags);
          });
        }
      };

      this.setup();
      this.initDraggable();
      this.bindEvents();
      this.initialized = true;
      return this;
    } // Methods
    // --------------------------------------------------

  }, {
    key: "setup",
    value: function setup() {
      var _this4 = this;

      // we need to get each item's image size to maintain its ratio
      this.$.items.get().forEach(function (item, index) {
        _this4.images.push(null);

        console.log(item.children); // imagesLoaded(item).progress(({ image }) => {
        //     this.images[index] = {
        //         width: image.width,
        //         height: image.height,
        //     };
        //     this.update();
        // });
      });
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this5 = this;

      // adapt each item's ratio to element's height
      var innerHeight = this.$.inner.height();
      this.$.items.get().forEach(function (item, index) {
        var image = _this5.images[index];

        if (image) {
          var $item = $d(item);
          var ratio = image.width / image.height;
          var width = innerHeight * ratio;
          $item.width(width);
        }
      }); // retrieve all needed dimensions

      this.elmWidth = this.$.wrapper[0].offsetWidth;
      this.innerWidth = this.$.inner[0].offsetWidth;
      this.minX = this.elmWidth - this.innerWidth; // hide arrows if track is smaller than viewport

      if (this.innerWidth <= this.elmWidth) {
        if (!this.$.arrows.first().hasClass('hidden')) {
          this.$.arrows.addClass('hidden');
        }
      } else if (this.$.arrows.first().hasClass('hidden')) {
        this.$.arrows.removeClass('hidden');
      } // update draggable instance


      if (this.draggable) {
        this.draggable.vars.bounds = this.getBounds();
        this.draggable.update(true);
      }
    }
  }, {
    key: "initDraggable",
    value: function initDraggable() {
      // bail if already initialized
      if (this.draggable) return;

      var _Draggable$create = Draggable.create(this.$.inner, {
        type: 'x',
        lockAxis: true,
        zIndexBoost: false,
        dragClickables: true,
        allowContextMenu: true,
        inertia: true,
        minimumMovement: 10,
        edgeResistance: 0.9,
        bounds: this.getBounds(),
        onClick: function onClick(e) {
          // this is to prevent strange behaviors under iOS (maybe due to Fastclick)
          if (e) e.stopPropagation();
        }
      }),
          _Draggable$create2 = _slicedToArray(_Draggable$create, 1),
          draggable = _Draggable$create2[0];

      this.draggable = draggable;
    }
  }, {
    key: "show",
    value: function show(index) {
      var _this6 = this;

      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.draggable) {
        return;
      }

      var $item = this.$.items.eq(index);
      var styles = window.getComputedStyle($item[0]);
      var marginLeft = parseInt(styles.marginLeft, 10);
      var x = $item.position().left + marginLeft;

      if (position === 'right') {
        var width = $item.outerWidth();
        x = x + width - this.elmWidth;
      }

      var clampedX = clamp(this.draggable.minX, this.draggable.maxX, -x);
      gsap.to(this.$.inner, {
        x: clampedX,
        duration: 0.5,
        ease: 'power2.inOut',
        onComplete: function onComplete() {
          _this6.draggable.update(true);
        }
      });
    }
  }, {
    key: "previous",
    value: function previous() {
      var visibles = this.getVisibleItems();
      var first = visibles[0];
      var index = first.index;

      if (first.index - 1 >= 0) {
        index = first.index - 1;
      } else if (first.cutted) {
        index = first.index;
      } else {
        index = this.$.items.length - 1;
      }

      this.show(index, 'left');
    }
  }, {
    key: "next",
    value: function next() {
      var visibles = this.getVisibleItems();
      var last = visibles[visibles.length - 1];
      var index = last.index;

      if (last.index + 1 <= this.$.items.length - 1) {
        index = last.index + 1;
      } else if (last.cutted) {
        index = last.index;
      } else {
        index = 0;
      }

      this.show(index, 'right');
    } // Helpers
    // --------------------------------------------------

  }, {
    key: "$select",
    value: function $select() {
      this.$ = this.$element.$select(this.options.$);
      this.$$ = this.options.$$;
    }
  }, {
    key: "getVisibleItems",
    value: function getVisibleItems() {
      var _this7 = this;

      if (!this.draggable) return [];
      var x = Math.abs(this.draggable.x);
      var visibles = [];
      this.$.items.get().forEach(function (item, index) {
        var $item = $d(item);
        var styles = window.getComputedStyle(item);
        var marginLeft = parseInt(styles.marginLeft, 10);
        var left = $item.position().left + marginLeft;
        var width = $item.outerWidth();

        if (left + width >= x && left <= x + _this7.elmWidth) {
          var cutted = !(left >= x && left + width <= x + _this7.elmWidth);
          visibles.push({
            cutted: cutted,
            index: index
          });
        }
      });
      return visibles;
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      return {
        minX: this.minX,
        maxX: 0
      };
    } // Events
    // --------------------------------------------------

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // global
      this.app.on('resize', this.onResize, this); // previous & next

      this.bounds.previous = this.previous.bind(this);
      this.bounds.next = this.next.bind(this);
      this.$element.on('click', this.$$.btnPrevious, this.bounds.previous);
      this.$element.on('click', this.$$.btnNext, this.bounds.next);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.update();
    }
  }]);

  return Carousel;
}(Component);

export { Carousel as default };

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}